var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card-text',{staticStyle:{"padding":"0px"}},[_c('MutationForm',{attrs:{"no-reset":"","mutation":"createView","constants":{ environmentId: _vm.environmentId },"submitButtonText":"Crear","submitButtonIcon":"add","submit-button-color":_vm.accentColor,"schema":{
        environmentId: {
          __graphQLType: 'ID'
        },
        path: {
          label: 'Ruta',
          type: 'string',
          description:
            'Debe empezar con /. Puedes añadir comodines de parámetro usando la sintáxis :parametro.',
          fieldOptions: {
            color: _vm.accentColor,
            placeholder: '/productos/:productoId',
            validatePattern: '^\/[\w\d:\-_\/%]+$',
            validateCaseInsensitive: true,
            validateCustomError:
              'Debe empezar con / y no puede contener espacios.'
          },
          newDesign: true
        },
        name: {
          label: 'Nombre para identificar la vista',
          type: 'string',
          description: 'Debe ser único y reconocible.',
          fieldOptions: {
            color: _vm.accentColor,
            placeholder: 'General Producto'
          },
          newDesign: true
        },
        title: {
          label: 'Título de la vista',
          type: 'string',
          description: 'Será mostrado al usuario.',
          fieldOptions: {
            color: _vm.accentColor,
            placeholder: 'Información de Producto'
          },
          newDesign: true
        }
      }},on:{"success":function($event){return _vm.$emit('create', $event)},"error":function($event){return _vm.$emit('error', $event)}}},[_c('v-btn',{attrs:{"slot":"left-buttons","dark":"","color":"#59a4f4"},on:{"click":function($event){return _vm.$emit('dismiss')}},slot:"left-buttons"},[_vm._v("Cancelar")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }